<template>
  <div>
    <div v-if="loading">
      <loading-spinner />
    </div>
    <div v-if="!loading">
      <!-- class="settings-content" -->
      <b-breadcrumb :items="navigationItems" />
      <b-modal
        id="create-publisher"
        ref="create-publisher"
        title="Create Publisher"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleCreateOk"
      >
        <p>This will create a new publisher with a randomly generated unique ID.</p>
        <form
          ref="createForm"
          @submit.stop.prevent="handleCreateSubmit"
        >
          <b-form-group
            :state="state.name"
            label="Publisher Name"
            label-for="name-create"
            invalid-feedback="Name is required"
          >
            <b-form-input
              id="name-create"
              ref="nameCreate"
              v-model="publisher.name"
              :state="state.name"
              required
            />
          </b-form-group>
          <b-form-group
            :state="state.description"
            label="Publisher Description"
            label-for="description-create"
            invalid-feedback="Description is required"
          >
            <b-form-input
              id="description-create"
              ref="descriptionCreate"
              v-model="publisher.description"
              :state="state.description"
              required
            />
          </b-form-group>
        </form>
      </b-modal>
      <b-modal
        id="edit-publisher"
        ref="editPublisher"
        title="Edit Publisher"
        @hidden="resetModal"
        @ok="handleEditOk"
      >
        <form
          ref="editForm"
          @submit.stop.prevent="handleEditSubmit"
        >
          <b-form-group
            :state="state.name"
            label="Edit Publisher Name"
            label-for="name-edit"
            invalid-feedback="Name is required"
          >
            <b-form-input
              id="name-edit"
              ref="nameEdit"
              v-model="publisher.name"
              :state="state.name"
              required
            />
          </b-form-group>
          <b-form-group
            :state="state.description"
            label="Edit Publisher Description"
            label-for="description-edit"
            invalid-feedback="Description is required"
          >
            <b-form-input
              id="description-edit"
              ref="descriptionEdit"
              v-model="publisher.description"
              :state="state.description"
              required
            />
          </b-form-group>
        </form>
      </b-modal>
      <b-modal
        id="delete-publisher"
        ref="deletePublisher"
        title="Delete Publisher Configurations"
        @ok="handleDeleteOK"
        @hidden="resetModal"
      >
        <p>Are you sure you want to delete : <b>{{ publisher.name }}</b></p>
      </b-modal>
      <b-container>
        <b-row>
          <h2>Publisher Selection</h2>
        </b-row>
        <b-row>
          <b-col
            cols="6"
            class="form-row"
          >
            <p>Select a publisher to configure payment options or a create a new one.</p>
            <b-form-checkbox
              v-model="showExpiring"
              plain
              class="ml-2"
            >
              Show Expiring
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="3"
            class="text-right align-self-center"
          >
            <label
              for="table-search"
            >Search:</label>
          </b-col>
          <b-col cols="3">
            <b-form-input
              id="table-search"
              v-model="search"
              type="text"
            />
          </b-col>
        </b-row>
        <div>
          <b-row align-v="center">
            <b-col
              cols="12"
              align-h="start"
            >
              <b-table
                v-b-scrollspy
                outlined
                striped

                :items="filteredItems"
                head-variant="light"
                :fields="computeTableFields"
                :filter="search"
                show-empty
                empty-text="No clients available"
              >
                <template v-slot:cell(clientId)="data">
                  <router-link
                    class="navigation-links"
                    :to="{name: 'configuration', params: { clientName: data.item.name, clientId: data.item.clientId }}"
                  >
                    {{ data.item.clientId }}
                  </router-link>
                </template>
                <template v-slot:cell(expiresAt)="data">
                  {{ data.item.expiresAt.toLocaleDateString() }} {{ data.item.expiresAt.toLocaleTimeString() }}
                </template>
                <template v-slot:cell(action)="data">
                  <b-link
                    v-b-modal="'edit-publisher'"
                    class="navigation-links"
                    @click="updatePublisher(data.item)"
                  >
                    Edit
                  </b-link>
                  |
                  <b-link
                    v-if="!data.item.expiresAt"
                    v-b-modal="'delete-publisher'"
                    class="navigation-links"
                    @click="updatePublisher(data.item)"
                  >
                    Delete
                  </b-link>
                  <b-link
                    v-if="data.item.expiresAt"
                    class="navigation-links"
                    @click="restoreClient(data.item.clientId)"
                  >
                    Restore
                  </b-link>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <br>
        </div>
        <div class="button-action-ct">
          <b-button
            v-b-modal.create-publisher
            variant="primary"
          >
            <i class="fa fa-plus-circle" /> Create New Publisher
          </b-button>
          <router-link :to="{name:'settings'}">
            <b-button
              variant="info"
              class="ml-3"
            >
              <i class="fa fa-cog" /> Settings
            </b-button>
          </router-link>
        </div>
      </b-container>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../UIComponents/LoadingSpinner'
import { dataAPI } from '../services/DataAPI.js'

export default {
  name: 'ClientSelection',
  components: {
    LoadingSpinner
  },

  data() {
    return {
      searchText: '',
      items: [],
      publisher: { clientId: null, name: null, description: null },
      state: { name: null, description: null },
      loading: true,
      search: null,
      showExpiring: false,
      filteredItems: [],
      fields: [
        {
          key: 'clientId',
          label: 'Publisher ID'
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true
        },
        {
          key: 'expiresAt',
          label: 'Expiration',
          sortable: true
        },
        {
          key: 'action',
          label: 'Actions'
        }
      ],
      navigationItems: [{
        text: 'Home',
        to: { name: 'home' }
      }, {
        text: 'Payments',
        active: true
      }]
    }
  },
  computed: {
    currentUserToken() {
      return this.$store.state.auth.userToken
    },
    computeTableFields() {
      if (this.showExpiring) {
        return this.fields
      }
      return this.fields.filter(f => f.key !== 'expiresAt')
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
    showExpiring: 'filterExpiring'
  },
  created() {
    this.fetchData()
  },
  methods: {
    hideEditModal() {
      this.$nextTick(() => {
        this.$refs.editPublisher.hide()
      })
    },
    hideDeleteModal() {
      this.$refs.deletePublisher.hide()
    },
    updatePublisher(item) {
      if (item) {
        this.publisher = item
      }
    },
    fetchData() {
      this.error = null
      this.loading = true
      dataAPI(this.currentUserToken).fetchClients_DataAPI().then((data) => {
        this.loading = false
        this.items = data
        this.filterExpiring()
      }).catch((error) => {
        this.error = error.toString()
      }).catch(function (error) {
        console.error('Error occurred fetching configs for Client: ', error)
        this.error = `Error loading page for ${this.clientSelectedCode}`
      })
    },
    checkFormValidity(id) {
      this.state = { name: null, description: null }
      if (id === 'create-publisher') {
        this.state.name = this.$refs.nameCreate.checkValidity()
        this.state.description = this.$refs.descriptionCreate.checkValidity()
      } else if (id === 'edit-publisher') {
        this.state.name = this.$refs.nameEdit.checkValidity()
        this.state.description = this.$refs.descriptionEdit.checkValidity()
      }
      return this.state.name && this.state.description
    },
    resetModal() {
      this.publisher = { clientId: null, name: null, description: null }
      this.state = { name: null, description: null }
    },
    handleCreateOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleCreateSubmit()
    },
    handleEditOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleEditSubmit()
    },
    handleDeleteOK() {
      this.handleDeleteSubmit()
    },
    handleCreateSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity('create-publisher')) {
        return
      }
      const { name, description } = this.publisher
      return dataAPI(this.currentUserToken)
        .createClient(name, description)
        .then((data) => {
          this.resetModal()
          return this.$router.push({
            name: 'configuration',
            params: {
              clientName: data.name,
              clientId: data.clientId
            }
          })
        }).catch(function (error) {
          console.error('Error occurred creating new publisher', error)
          this.error = `Error creating publisher for ${name}`
        })
    },
    handleDeleteSubmit() {
      const { clientId } = this.publisher
      if (!clientId) {
        console.log('no clientID')
        return
      }
      return dataAPI(this.currentUserToken)
        .deleteClient(clientId)
        .then((data) => {
          this.resetModal()
          this.hideDeleteModal()
          this.fetchData()
        }).catch(function (error) {
          console.error('Error occurred deleting  publisher', error)
          this.error = `Error deleting publisher for ${clientId}`
        })
    },
    handleEditSubmit() {
      // Show vlaidation Error when there is no name
      if (!this.checkFormValidity('edit-publisher')) {
        return
      }
      const { clientId, name, description } = this.publisher
      return dataAPI(this.currentUserToken)
        .updateClient(clientId, name, description)
        .then((data) => {
          this.hideEditModal()
          this.resetModal()
        }).catch(function (error) {
          console.error('Error occurred editing  publisher', error)
          this.error = `Error editing publisher for ${clientId}`
        })
    },
    publishAllConfigurations() {
      return dataAPI(this.currentUserToken).publishAllConfigurations()
    },
    filterExpiring() {
      this.filteredItems = this.items.filter(item => {
        return this.showExpiring ? item.expiresAt !== undefined : item.expiresAt === undefined
      })
    },
    deleteClient(clientId) {
      return dataAPI(this.currentUserToken).deleteClient(clientId)
        .then(() => {
          this.fetchData()
        })
    },
    restoreClient(clientId) {
      return dataAPI(this.currentUserToken).restoreClient(clientId)
        .then(() => {
          this.fetchData()
        })
    }
  }

}
</script>

